import {defineStore} from 'pinia'
import api from '@/services/api'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'

export const useUserRolesStore = defineStore('userRoles', {
    state: () => ({
        roles: {},
        options: [
            {name: 'add', title: 'Add'},
            {name: 'edit', title: 'Edit'},
            {name: 'archive', title: 'Archive'},
            {name: 'delete', title: 'Delete'},
            {name: 'publish', title: 'Publish'},
            {name: 'export', title: 'Export'}
        ],
        privileges: {}
    }),
    
    getters: {
        getPrivileges: (state) => (roleId, componentId) => {
            if (state.privileges[roleId] === undefined) {
                state.privileges[roleId] = {}
            }
            if (state.privileges[roleId][componentId] === undefined) {
                state.privileges[roleId][componentId] = []
            }
            
            return state.privileges[roleId][componentId]
        }
    },
    
    actions: {
        async init() {
            const userStore = useUserStore()
            const componentsStore = useComponentsStore()
            
            const roles = {}
            const user = userStore.user || {}
            const componentsItems = componentsStore.items || []
            
            componentsItems.forEach((obj) => {
                const rolesGroup = obj.rolesGroup
                if (obj.roles && rolesGroup) {
                    if (roles[rolesGroup] === undefined) {
                        roles[rolesGroup] = {}
                    }
                    if (roles[rolesGroup][obj.title] === undefined) {
                        roles[rolesGroup][obj.title] = {}
                    }
                    
                    this.options.forEach((option) => {
                        const name = option.name
                        const title = option.title
                        if (
                            (name === 'add' && obj.addNew) ||
                            (name === 'delete' && obj.deleteOption) ||
                            (name === 'publish' && obj.showStatus) ||
                            ['add', 'delete', 'publish'].indexOf(name) === -1
                        ) {
                            const hasAccess = userStore.access(obj.tableName, name)
                            
                            if (user.administrator || hasAccess) {
                                roles[rolesGroup][obj.title][name] = {
                                    label: title,
                                    name: name,
                                    tableName: obj.tableName
                                }
                            }
                        }
                    })
                }
            })
            
            this.roles = roles
            await this.setPrivileges()
        },
        
        async setPrivileges() {
            try {
                const response = await api.get('api/roles')
                this.privileges = response.data?.privileges || {}
            } catch (error) {
                console.error('Failed to fetch roles privileges:', error)
            }
        },
        
        initRole(roleId) {
            if (!this.privileges[roleId]) {
                this.privileges[roleId] = {}
            }
        },
        
        togglePrivilege({roleId, componentId, privilege}) {
            if (!this.privileges[roleId]) {
                this.privileges[roleId] = {}
            }
            if (this.privileges[roleId][componentId] === undefined) {
                this.privileges[roleId][componentId] = []
            }
            
            const privileges = this.privileges[roleId][componentId]
            const i = privileges.indexOf(privilege)
            
            if (i === -1) {
                privileges.push(privilege)
                privileges.sort()
            } else {
                privileges.splice(i, 1)
                
                if (Object.keys(privileges).length === 0) {
                    delete this.privileges[roleId][componentId]
                }
            }
        }
    }
})